import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { addeditUsersCategory, deleteUserCategory } from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import LocaleStrings from "Languages";

class CategoryListItem extends Component {
  constructor(props) {
    super(props);
  }

  deleteCategoryCallback() {
    var { allCategories } = this.props;
    var attendee = _.filter(allCategories, (obj) => {
      return obj.type === "attendee";
    });
    confirmAlert({
      title: LocaleStrings.user_manage_user_category_title_delete_category,
      message: LocaleStrings.user_manage_user_category_text_are_you_sure_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteUserCategory(
              this.props.session,
              this.props.category,
              attendee[0],
              (result) => {
                if (result.success) {
                  this.props.showSuccess(
                    LocaleStrings.user_manage_user_category_message_category_deleted
                  );
                  this.props.recallAppuser();
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  editCategoryCallback(obj) {
    var cat = { ...this.props.category, toAdd: false, toEdit: true };
    this.props.addeditUsersCategory(cat);
  }

  render() {
    var { category } = this.props;

    return (
      <tr key={category.id}>
        <td>
          <div className="vcenter">{category.groupname}</div>
        </td>
        <td>
          <div className="action-button-area">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editCategoryCallback.bind(this)}
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            {category.type == "custom" ? (
              <div className="action-button vcenter">
                <button
                  className="i-custom-table-delete"
                  onClick={this.deleteCategoryCallback.bind(this)}
                >
                  <img
                    className="i-custom-table"
                    src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                  />
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  addeditUsersCategory,
  deleteUserCategory,
  showError,
  showSuccess,
})(CategoryListItem);
